import { CurrencyCode, TerminalInventoryStatus } from "Infrastructure/Api/Api";
import { Resources, type TFunction } from "Translations/Resources";
import { z } from "zod";

const RESOURCES = Resources.Admin.Terminals;

export const getEditTerminalSchema = (t: TFunction) =>
  z.object({
    serialNumber: z
      .string()
      .min(1, t(RESOURCES.Validation.SerialNumberRequired)),
    hardwareModel: z
      .string()
      .min(1, t(RESOURCES.Validation.HardwareModelRequired)),
    hunter: z
      .object({ partyPublicID: z.string(), label: z.string() })
      .nullable(),
    purchasePrice: z.number().nullish(),
    purchasePriceCurrencyCode: z.nativeEnum(CurrencyCode),
    status: z.nativeEnum(TerminalInventoryStatus),
  });

export type EditTerminalFormData = z.infer<
  ReturnType<typeof getEditTerminalSchema>
>;
export type HunterOption = NonNullable<EditTerminalFormData["hunter"]>;
